import axios from 'axios';
import _ from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';

/**
 * Logica comune delle schede Nuova / Modifica tab aggiuntiva.
 * L'elenco delle tab si salva intero (POST profile/product-additional-tab): il componente
 * fornisce `listaDaSalvare()` con la tab nuova o modificata gia' dentro, senza toccare lo store
 * prima della risposta (se il salvataggio fallisce l'elenco resta com'era).
 */
export default {
	data() {
		return {
			item: {
				trans: [],
				is_active: true,
				position: 0,
			},
			// errori per lingua nello stesso ordine di item.trans: [{ name }]
			errorsTrans: [],
			alerts: { is_active: '', position: '' },
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		...mapGetters({
			getUrl: 'settings/getUrl',
			getSettings: 'settings/getSetting',
			getToken: 'profile/getToken',
		}),
		// lingue attive, la predefinita per prima
		lingueAttive() {
			return _.orderBy(_.filter(this.getSettings.languages || [], { is_active: true }), ['default'], ['desc']).map(l => l.lang);
		},
		// le altre tab, per l'anteprima dell'ordine
		altreTab() {
			return (this.getSettings.additional_tabs || []).filter(t => !this.id || t._id !== this.id);
		},
	},
	methods: {
		...mapMutations({
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setLogout: 'profile/setLogout',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			updateSettings: 'settings/updateData',
		}),
		// trans con tutte le lingue attive, riprendendo i nomi gia' presenti
		preparaTrans(esistenti = []) {
			this.item.trans = this.lingueAttive.map(lang => {
				const t = _.find(esistenti, { lang });
				return { lang, name: t ? t.name : '' };
			});
			this.errorsTrans = this.item.trans.map(() => ({ name: '' }));
		},
		valida() {
			this.errorsTrans = this.item.trans.map(() => ({ name: '' }));
			this.alerts = { is_active: '', position: '' };
			const errori = [];
			if (!_.get(this.item, 'trans[0].name')) {
				this.errorsTrans[0].name = 'Nome richiesto';
				errori.push('Nome richiesto');
			}
			if (!_.isBoolean(this.item.is_active)) {
				this.alerts.is_active = 'Scegli se è attiva';
				errori.push('Stato richiesto');
			}
			if (this.item.position === '' || this.item.position === null || +this.item.position < 0) {
				this.alerts.position = 'Posizione obbligatoria (0 o più)';
				errori.push('Posizione obbligatoria');
			}
			return errori;
		},
		async confirm() {
			const errori = this.valida();
			if (errori.length) {
				this.showSnackBar('error', errori.join(' <br>'));
				return;
			}
			const items = _.orderBy(this.listaDaSalvare(), [t => +t.position], ['asc']);
			this.setPreload(true);
			try {
				const { data } = await axios.post(`${this.getUrl}profile/product-additional-tab`, items, { headers: { Authorization: `Bearer ${this.getToken}` } });
				await this.updateSettings(data.data);
				this.$emit('message', 'success', 'Operazione effettuata con successo');
				this.setDialog(false);
				this.$emit('close');
			} catch (err) {
				if (err.response && err.response.status === 401) {
					this.setLogout();
					this.$router.push('/login');
				}
				this.showSnackBar('error', err.message);
			} finally {
				this.setPreload(false);
			}
		},
		close() {
			this.$emit('close');
			this.setDialog(false);
		},
		showSnackBar(mode, message) {
			this.snackbar.color = mode;
			this.snackbar.text = message;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		// traduce il nome della prima lingua in tutte le altre
		traduci() {
			const master = _.get(this.item, 'trans[0].name');
			if (!master) return;
			this.item.trans.slice(1).forEach(tran => {
				const formData = { target: tran.lang, words: { title: master } };
				axios
					.post(`${this.getUrl}translates`, { data: formData }, { headers: { Authorization: `Bearer ${this.getToken}` } })
					.then(res => {
						tran.name = decodeURIComponent(res.data.data[0]);
					})
					.catch(err => {
						console.log(err);
					});
			});
		},
	},
};
